export enum Status {
  DISABLED = 'disabled',
  ENABLED = 'enabled',
  ACTIVE = 'active',
  COMPLETED = 'completed',
  EMPTY = '',
}

export interface Step {
  id: string
  number: number
  path: string
  label: string
  status: Status
}

export interface Steps {
  [key: string]: Step
}
